import React from "react";
import { getBugsnagReactErrorBoundary } from "@/services/bugsnag";

const BugsnagReactReports = getBugsnagReactErrorBoundary() || React.Fragment;

export default BugsnagReactReports;
